import Paragraph from '@tiptap/extension-paragraph';

export const CustomParagraph = Paragraph.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      // Zorgt dat data-placeholder uit de backend behouden blijft
      'data-placeholder': {
        default: null,
        parseHTML: element => element.getAttribute('data-placeholder'),
        renderHTML: attributes => {
          if (!attributes['data-placeholder']) return {};
          return { 'data-placeholder': attributes['data-placeholder'] };
        },
      },
      // Behoudt inline style attributen op <p> tags
      style: {
        default: null,
        parseHTML: element => element.getAttribute('style'),
        renderHTML: attributes => {
          if (!attributes.style) return {};
          return { style: attributes.style };
        },
      },
    };
  },
  content: 'inline*',
});